const ufeApi = require('services/api/ufeApi');

// https://confluence.sephora.com/wiki/display/ILLUMINATE/GET+ROPIS+Specific+Product+Details

function getRopisSpecificProductDetails(profileId = 'current', productId, skuId = null) {
    let url = `/api2/users/profiles/${profileId}/ropisproduct/${productId}`;
    let queryParams = [];

    if (skuId !== null) {
        queryParams.push(`?preferedSku=${skuId}`);
    }

    url = url + queryParams.join('&');
    return ufeApi.makeRequest(url, {
        method: 'GET'
    }).then(data => data.errorCode ? Promise.reject(data) : data);
}

module.exports = getRopisSpecificProductDetails;
